
export const onClientEntry = () => {
  const path = window.location.pathname;

  // 1. Redirect root to /latest
  if (path === "/") {
    window.location.replace("/latest");
    return;
  }

  // 2. Redirect old versions (4.9 / 5.0)
  // if (path.includes("/4.9") || path.includes("/5.0")) {
  //  window.location.replace("https://docs4.incorta.com" + path);
  //  return;
  // }

  // 3. Redirect legacy Home pages to their /latest versions
  if (path === "/home/incorta-release-support-policy") {
    window.location.replace("/latest/incorta-release-support-policy");
    return;
  }

  if (path === "/home/release-model") {
    window.location.replace("/latest/release-model");
    return;
  }
  // 4. Redirect old versions (cloud / 6.0 / 5.2 / 5.1)
  // const params = new URLSearchParams(window.location.search);
  // if (params.has("noredirect")) return;

  // if (path.includes("/5.1") || path.includes("/5.2") || path.includes("/6.0") || path.includes("/cloud")) {
     //  const strippedPath = path.replace(/^\/(5\.1|5\.2|6\.0|cloud)/, "");
      // const newPath = "/latest" + strippedPath;
      // fetch(newPath, { method: "HEAD" })
      //    .then(res => {
        //      window.location.replace(res.ok ? newPath : "/latest");
        //  })
        //  .catch(() => {
          //    window.location.replace("/latest");
          // });
      // return;
  // }



  // if (path.includes("/5.1") || path.includes("/5.2") || path.includes("/6.0") || path.includes("/cloud")) {
    //  const params = new URLSearchParams(window.location.search);
    //  if (params.has("noredirect")) return;  // ← check here, after path match

    //  const strippedPath = path.replace(/^\/(5\.1|5\.2|6\.0|cloud)/, "");
  //    const newPath = "/latest" + strippedPath;
    //  fetch(newPath, { method: "HEAD" })
      //    .then(res => {
        //      window.location.replace(res.ok ? newPath : "/latest");
        //  })
        //  .catch(() => {
          //    window.location.replace("/latest");
          // });
      // return;
  // }


  if (path.includes("/5.1") || path.includes("/5.2") || path.includes("/6.0") || path.includes("/cloud") || path.includes("/4.9") || path.includes("/5.0")) {
      const params = new URLSearchParams(window.location.search);

      if (params.has("noredirect")) {
          sessionStorage.setItem("noredirect", "1");
          return;
      }

      if (sessionStorage.getItem("noredirect")) return;

      const strippedPath = path.replace(/^\/(5\.1|5\.2|6\.0|cloud|5\.0|4\.9)/, "");
      const newPath = "/latest" + strippedPath;
      fetch(newPath, { method: "HEAD" })
          .then(res => {
              window.location.replace(res.ok ? newPath : "/latest");
          })
          .catch(() => {
              window.location.replace("/latest");
          });
      return;
  }
    
};
